import { ICellRendererParams } from "ag-grid-community";
import { TriangleAlert } from "lucide-react";

import { IgTooltip } from "@intelligems/ig-theme";
import { AgencySubscriptionProductLinkDto } from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";

export const NameColumn = (
  params: ICellRendererParams<AgencySubscriptionProductLinkDto>
) => {
  const theme = useTheme();
  if (!params.data) {
    return null;
  }

  if (params.data?.id === "grandTotal") {
    return null;
  }

  return (
    <Grid container columnSpacing={1} alignItems={"center"}>
      {params.data["dangling"] ? (
        <Grid item mt={0.5}>
          <IgTooltip
            title={"Organization not linked to Agency"}
            open={true}
            slotProps={{ tooltip: "df", popper: "df" }}
          >
            <TriangleAlert color={theme.igIconColors.warning} />
          </IgTooltip>
        </Grid>
      ) : null}
      <Grid item>{params.data.organization.name}</Grid>
    </Grid>
  );
};
